// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"444":"e8e781d7","850":"98502ab4"}[chunkId] + ".chunk.js";
};